<div class="meta-options">
  <div
    *ngFor="let fieldGroupField of field.fieldGroup; let index = index; let first = first"
    class="option-form d-flex">
    <div class="flex-grow-1">
      <formly-field [field]="fieldGroupField"></formly-field>
    </div>

    <div class="remove-btn">
      <i class="fas fa-trash-can" (click)="remove(index)"></i>
    </div>
  </div>

  <div class="repeat-add-button">
    <cap-button
      icon="fas fa-plus"
      [label]="'market_discovery.meta-key.add-option' | translate"
      styleClass="primary"
      (onClick)="add()">
    </cap-button>
  </div>
</div>
